import * as Sentry from '@sentry/nextjs'
import { Meilisearch } from 'meilisearch'
import { MAIN_INDEX_ID } from './mainIndex'

const MEILISEARCH_URL =
  process.env.MEILISEARCH_URL || process.env.NEXT_PUBLIC_MEILISEARCH_URL

export const meilisearchMasterClient = MEILISEARCH_URL
  ? new Meilisearch({
      host: MEILISEARCH_URL,
      apiKey: process.env.MEILI_MASTER_KEY,
    })
  : undefined

export async function getEmbeddingModel() {
  try {
    const embedders = await meilisearchMasterClient
      ?.index(MAIN_INDEX_ID)
      .getEmbedders()
    if (!embedders) return null
    return Object.keys(embedders)[0] ?? null
  } catch (error) {
    console.error('Failed to get embedding model', error)
    Sentry.captureException(error)
    return null
  }
}
